// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1_Afn","cls2":"Timer-cls2_KV9 Timer-cls1_Afn","darkDigits":"Timer-darkDigits_BNv"};